document.addEventListener('DOMContentLoaded', function () {
  window.localStorage.setItem('swym-products_timestamp', '0');
  window.localStorage.removeItem('swym-products');

  setTimeout(() => {
    const swymStorage = window.localStorage.getItem('swym-products');
    let lid = null;

    if (swymStorage) {
      const swymData = JSON.parse(swymStorage);
      if (swymData && swymData.all.length > 0) {
        lid = swymData.all.map((item) => item.empi).join(',');
      }
    }

    if (lid) {
      document.addEventListener('click', function (event) {
        const shareButton = event.target.closest('.swym-share-btn');
        if (shareButton) {
          event.preventDefault();
          event.stopImmediatePropagation();
          copyToClipboardSharedUrl(lid);
        }
      });
    }
  }, 1000);

  const copyToClipboardSharedUrl = (lid) => {
    const shareURL =
      window.location.origin + '/pages/wishlist-share?lid=' + lid;

    navigator.clipboard.writeText(shareURL);
    modifyModal();
  };

  const modifyModal = () => {
    const targetNode = document.body;
    const config = { childList: true, subtree: true };

    const callback = (mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const heading = document.querySelector('.swym-text-heading');
          if (heading) {
            heading.innerText = 'Copied to clipboard!';
            heading.style.marginBottom = '0px';

            const loginBtn = document.querySelector('.swym-login-btn');
            if (loginBtn) {
              loginBtn.style.display = 'none';
            }

            const textElements = document.querySelectorAll('.swym-text');
            textElements.forEach((el) => {
              el.style.display = 'none';
            });

            observer.disconnect();
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  };
});
